/* 中文词典：dev 命名空间。见 src/i18n/README.md。 */

import type { TextSpec } from '../text';

const dev = {
  'dev.render.title': [ '象牙轮盘' ],
  'dev.render.subtitle': [ '后端调试终端' ],
  'dev.render.phase': [ '阶段' ],
  'dev.render.drawPile': [ '牌堆' ],
  'dev.render.discardPile': [ '弃牌堆' ],
  'dev.render.out': [ '(出局)' ],
  'dev.render.disconnected': [ '断线' ],
  'dev.render.seats': [ '座位' ],
  'dev.render.host': [ '   (你是房主)' ],
  'dev.render.attacked': [ ' · 被攻击' ],
  'dev.render.turn': [ '回合' ],
  'dev.render.turnTo': [ '轮到 ', { type: 'param', name: 'who' } ],
  'dev.render.actionsLeft': [ '（还要行动 ', { type: 'param', name: 'n' }, ' 次）' ],
  'dev.render.viewpoint': [ '视角' ],
  'dev.render.eliminated': [ '(已出局)' ],
  'dev.render.emptyHand': [ '手牌为空' ],
  'dev.render.othersHands': [ '其他人手牌数：' ],
  'dev.render.knownTop': [ '你知道牌堆顶：' ],
  'dev.render.responseWindow': [ '▶ 响应窗口' ],
  'dev.render.playedBy': [ { type: 'param', name: 'actor' }, ' 打出了' ],
  'dev.render.nopeChain': [ '打断链 ', { type: 'param', name: 'n' }, ' 张 → 效果' ],
  'dev.render.willCancel': [ '将被取消' ],
  'dev.render.willApply': [ '会生效' ],
  'dev.render.eligible': [ '有资格打断的人：' ],
  'dev.render.none': [ '（没有）' ],
  'dev.render.drewRescue': [ '抽到了 ', { type: 'param', name: 'card' }, '，用不用救命牌？' ],
  'dev.render.insertWhere': [ '把 ', { type: 'param', name: 'card' }, ' 插回牌堆的哪个位置？' ],
  'dev.render.giveOne': [ '选一张牌交给对方' ],
  'dev.render.giveNamed': [ '交出一张「', { type: 'param', name: 'title' }, '」' ],
  'dev.render.stealOne': [ '从对方手里挑一张（共 ', { type: 'param', name: 'n' }, ' 张牌背）' ],
  'dev.render.pickDiscard': [ '从弃牌堆里挑一张' ],
  'dev.render.pending': [ '▶ 待抉择' ],
  'dev.render.gameOver': [ '对局结束' ],
  'dev.render.noWinner': [ '没有赢家（平局）' ],
  'dev.render.wins': [ { type: 'param', name: 'name' }, ' 赢了' ],
  'dev.render.event.played': [ '打出 ', { type: 'param', name: 'n' }, ' 张（', { type: 'param', name: 'kind' }, '）' ],
  'dev.render.event.drawn': [ { type: 'param', name: 'player' }, ' 抽了一张', { type: 'param', name: 'secret' } ],
  'dev.render.event.secret': [ '（保密）' ],
  'dev.render.event.stolen': [ { type: 'param', name: 'by' }, ' 从 ', { type: 'param', name: 'from' }, ' 手里抢走一张' ],
  'dev.render.event.given': [ { type: 'param', name: 'by' }, ' 交给 ', { type: 'param', name: 'to' }, ' 一张' ],
  'dev.render.event.reclaimed': [ { type: 'param', name: 'by' }, ' 从弃牌堆捞回一张' ],
  'dev.render.event.windowOpened': [ '打开响应窗口' ],
  'dev.render.event.noped': [ { type: 'param', name: 'player' }, ' 打出休想' ],
  'dev.render.event.windowCancelled': [ '窗口关闭（效果被取消）' ],
  'dev.render.event.windowApplied': [ '窗口关闭（效果生效）' ],
  'dev.render.event.lethalDrawn': [ { type: 'param', name: 'player' }, ' 抽到了致命牌！' ],
  'dev.render.event.lethalDefused': [ { type: 'param', name: 'player' }, ' 拆掉了它' ],
  'dev.render.event.lethalExploded': [ { type: 'param', name: 'player' }, ' 爆炸出局' ],
  'dev.render.event.shuffled': [ '牌堆被洗乱' ],
  'dev.render.event.peeked': [ { type: 'param', name: 'player' }, ' 私密看了牌堆顶' ],
  'dev.render.event.attacked': [ { type: 'param', name: 'player' }, ' 被攻击，欠 ', { type: 'param', name: 'n' }, ' 个回合' ],
  'dev.render.event.turnStarted': [ '轮到 ', { type: 'param', name: 'player' } ],
  'dev.render.event.turnEnded': [ { type: 'param', name: 'player' }, ' 的回合结束' ],
  'dev.render.event.won': [ { type: 'param', name: 'player' }, ' 获胜' ],
  'dev.sim.duplicate': [ '同一张卡牌实例出现在多个地方' ],
  'dev.sim.leaked': [ '有 ', { type: 'param', name: 'missing' }, ' 张卡牌不在任何地方（卡表 ', { type: 'param', name: 'total' }, '，场内 ', { type: 'param', name: 'seen' }, '）' ],
  'dev.sim.noSuchPlayer': [ '回合指向不存在的玩家 ', { type: 'param', name: 'id' } ],
  'dev.sim.deadHolder': [ '回合停在了出局的 ', { type: 'param', name: 'name' }, ' 身上' ],
  'dev.sim.discardShrank': [ '弃牌堆从 ', { type: 'param', name: 'from' }, ' 变短到 ', { type: 'param', name: 'to' }, '，但没人捞牌' ],
  'dev.sim.noActor': [ '对局还在进行，但找不到该行动的人' ],
  'dev.sim.pendingDecision': [ '（待抉择：', { type: 'param', name: 'kind' }, '）' ],
  'dev.sim.responseWindowOpen': [ '（响应窗口开着）' ],
  'dev.sim.noLegalAction': [ '轮到 ', { type: 'param', name: 'actor' }, ' ', { type: 'param', name: 'pending' }, { type: 'param', name: 'window' }, '，但他没有任何合法动作' ],
  'dev.sim.noWinner': [ '对局结束却没有赢家（存活 ', { type: 'param', name: 'alive' }, ' 人，牌堆 ', { type: 'param', name: 'draw' }, ' 张）' ],
  'dev.sim.reachedEnd': [ '走到结束' ],
  'dev.sim.noActorShort': [ '找不到该行动的人' ],
  'dev.sim.botStuck': [ '机器人无路可走' ],
  'dev.sim.rejected': [ '第 ', { type: 'param', name: 'step' }, ' 步，机器人挑的动作被拒：', { type: 'param', name: 'reason' } ],
  'dev.sim.noProgress': [ '第 ', { type: 'param', name: 'step' }, ' 步，动作 ', { type: 'param', name: 'action' }, ' 没有推进局面' ],
  'dev.sim.wedged': [ { type: 'param', name: 'reason' }, '，跑了 ', { type: 'param', name: 'steps' }, ' 步还没结束（牌堆 ', { type: 'param', name: 'draw' }, ' 张，存活 ', { type: 'param', name: 'alive' }, ' 人）' ],
  'dev.sim.setupFailed': [ '搭建对局失败：', { type: 'param', name: 'reason' } ],
  'dev.sim.violation': [ '[', { type: 'param', name: 'code' }, '] 种子 ', { type: 'param', name: 'seed' }, '（', { type: 'param', name: 'players' }, ' 人 / ', { type: 'param', name: 'profile' }, '）：', { type: 'param', name: 'message' } ],
  'dev.sim.ranRounds': [ ' 跑了 ', { type: 'param', name: 'n' }, ' 局随机对局（', { type: 'param', name: 'profiles' }, ' 种机器人轮换）' ],
  'dev.sim.avgSteps': [ ' 平均每局 ', { type: 'param', name: 'n' }, ' 步' ],
  'dev.sim.endings': [ ' 结束方式' ],
  'dev.sim.winnerCount': [ '有人获胜 ', { type: 'param', name: 'n' } ],
  'dev.sim.noWinnerCount': [ '没有赢家 ', { type: 'param', name: 'n' } ],
  'dev.sim.wedgedCount': [ '卡死 ', { type: 'param', name: 'n' } ],
  'dev.sim.profileLine': [ { type: 'param', name: 'total' }, ' 局，有赢家 ', { type: 'param', name: 'winner' }, '（', { type: 'param', name: 'rate' }, '%）' ],
  'dev.sim.hitRates': [ ' 规则区域命中率（每局平均）' ],
  'dev.sim.playKinds': [ '出牌种类  单张 ', { type: 'param', name: 'single' }, '  一对 ', { type: 'term', term: 'pair' }, '  三张 ', { type: 'term', term: 'triple' }, '  五张 ', { type: 'term', term: 'fiveDifferent' } ],
  'dev.sim.lethal': [ '致命结算  抽到 ', { type: 'param', name: 'drawn' }, '  拆掉 ', { type: 'param', name: 'defused' }, '  炸死 ', { type: 'param', name: 'exploded' } ],
  'dev.sim.decisions': [ '抉择' ],
  'dev.sim.insertAt': [ '插回位置' ],
  'dev.sim.window': [ '窗口      效果生效 ', { type: 'param', name: 'applied' }, '  被取消 ', { type: 'param', name: 'cancelled' }, '  最长休想链 ', { type: 'param', name: 'maxChain' } ],
  'dev.sim.other': [ '其他      还有人活着时抽空 ', { type: 'param', name: 'emptied' }, ' 次  出局者打过休想 ', { type: 'param', name: 'deadNoped' }, '  攻击回合数' ],
  'dev.sim.allGood': [ ' ✅ 没有致命问题：没有死锁、没有丢牌或重复牌、回合不会停在出局者身上' ],
  'dev.sim.fatalFound': [ ' ❌ 发现 ', { type: 'param', name: 'n' }, ' 个致命问题：' ],
  'dev.sim.softFound': [ ' ⚠️ ', { type: 'param', name: 'n' }, ' 个软性问题（规则允许但值得看）：' ],
} as const;

// 静态检查（写在对象字面量之外，避免 TextKey 循环推断）
dev satisfies Record<string, TextSpec>;
export default dev;
